import React from 'react';
import { Typography } from 'antd';
import classNames from 'classnames';

const { Text } = Typography;

/**
 * SummaryNotes Component
 *
 * Renders notes section with muted text
 */
export const SummaryNotes = ({ notes = [], className = '' }) => {
    if (!Array.isArray(notes) || notes.length === 0) {
        return null;
    }

    return notes.map((note, idx) => {
        const { text, type } = note;
        return (
            <span className="summary-notes-content" key={idx}>
                <Text className={classNames('rm-card-muted-label', className)}>{text}</Text>
            </span>
        );
    });
};

SummaryNotes.displayName = 'SummaryNotes';

export default SummaryNotes;
